import React, { useState, useEffect, useContext } from 'react'
import Link from 'next/link'
import axios from 'axios'
import { format } from 'date-fns'
import { style } from './NewsItems.style'
import { Category, getCategoryJp, Query } from '../../utils/news'
import { CategoryContext } from './CategoryContext'
import { addHoverEvent } from '../../utils/addHoverEvent'
import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

type Title = {
  rendered: string
}

type Image = {
  rendered: string
}

type OwnProps = {
  id: number
  img: number
  date: string
  category: Category[]
  subcategory: 'event' | 'report'
  title: Title
}

const NewsItems = (props: OwnProps) => {
  const { id, img, date, category, subcategory, title } = props
  const [image, setImage] = useState<Image | null>(null)
  const query: Query = {
    subcategory,
    university: useContext(CategoryContext),
  }

  useEffect(() => {
    if (img) {
      const fetchData = async () => {
        const res = await axios.get(
          `${process.env.NEXT_PUBLIC_API_BASE_URL}${process.env.NEXT_PUBLIC_MEDIA}/${img}`,
        )

        setImage(res.data.guid)
      }
      fetchData()
    }

    // Processing when hovering to a tag
    addHoverEvent()
  }, [])

  return (
    <Link
      as={`/news/detail?nid=${id}`}
      href={{ pathname: `/news/detail`, query }}
    >
      <a css={style.card}>
        <div css={style.wrapImage}>
          {(() => {
            if (image && image.rendered) {
              return <img src={image.rendered} css={style.image} />
            } else {
              return (
                <img src={`${basePath}/common/noimage.png`} css={style.image} />
              )
            }
          })()}
        </div>
        <div css={style.info}>
          <div css={style.categories}>
            {category.map((val, i) => {
              return (
                <p key={i} css={style.category(val)}>
                  {getCategoryJp(val)}
                </p>
              )
            })}
          </div>
          <p css={style.date}>{format(new Date(date), 'yyyy.MM.dd')}</p>
        </div>
        <p css={style.title}>{title.rendered}</p>
      </a>
    </Link>
  )
}

export default NewsItems
